import axios from '../axiosInstance';

export async function getTransTypes({ search = '', pageSize = 50, lastId = null, signal = null } = {}) {
    const { data } = await axios.get('/TransTypes/getTransTypes', { params: { search, pageSize, lastId }, signal });
    return data; // { items, lastId, hasMore }
}

export async function getTransTypesEnabled({ search = '', pageSize = 50, lastId = null, signal = null } = {}) {
    const { data } = await axios.get('/TransTypes/getEnabled', { params: { search, pageSize, lastId }, signal });
    return data;
}

export async function getTransTypeById(id, signal = null) {
    const { data } = await axios.get(`/TransTypes/${id}`, { signal });
    return data;
}
